import { Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

interface ContentHeaderWrapperProps {
  clickable: boolean
}

export const ContentHeaderWrapper = styled.div<ContentHeaderWrapperProps>`
  display: flex;
  gap: ${Spacing.S80};
  justify-content: space-between;
  margin-bottom: ${Spacing.S16};

  ${({ clickable }) =>
    clickable &&
    css`
      user-select: none;

      &:hover {
        cursor: pointer;
      }
    `}
`

export const TitleAndSubtitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S8};
`

export const SideActionsWrapper = styled.div``
